import { render } from "./AgendaVueSection.vue?vue&type=template&id=52620aaf&scoped=true"
import script from "./AgendaVueSection.vue?vue&type=script&lang=js"
export * from "./AgendaVueSection.vue?vue&type=script&lang=js"

import "./AgendaVueSection.vue?vue&type=style&index=0&id=52620aaf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52620aaf"]])

export default __exports__